import axios from '@/plugins/axios.js'
// 是否已授权
export const isAuthorized = () => axios.get('/user/isAuthorized')

// 渠道授权
export const toGrantAuthorization = (params) => axios.post('/user/authorityChannels', undefined, {params})

//取消授权
export const cancelAuthorized = () => axios.get('/user/cancelAuthorized')